import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST;
export const CONSENT_KEY = "lwe_analytics_consent";

// The Emergent platform runs its OWN posthog-js on the default instance. To avoid competing
// with its shared global state, register ours as a distinct NAMED instance ("lwe").
let client = posthog;
if (KEY) {
  client = posthog.init(
    KEY,
    {
      api_host: HOST,
      autocapture: true,
      capture_pageview: false, // captured manually on route change (SPA)
      capture_pageleave: true,
      person_profiles: "identified_only",
      // Start opted-out so NOTHING is captured until we reconcile the stored choice below.
      opt_out_capturing_by_default: true,
    },
    "lwe",
  );
  // Single source of truth = our stored consent, applied synchronously before any capture runs
  // (this executes at module load, before React mounts PageviewTracker). Analytics is ON by
  // default (product decision): only an explicit "denied" keeps the user opted out.
  const choice = typeof window !== "undefined" ? window.localStorage.getItem(CONSENT_KEY) : null;
  if (choice === "denied") {
    client.opt_out_capturing();
  } else {
    client.opt_in_capturing();
  }
}

export default client;
